<template>
  <div>
    <h1 v-if="showHeader" class="mb-3">Allgemeine Gesch&auml;ftsbedingungen</h1>

    <static-content which="terms-and-conditions"/>
  </div>
</template>

<script>
import StaticContent from "@/widgets/StaticContent"

export default {
  name: "AGBs",
  components: {
    StaticContent,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
h2 {
  margin-bottom: 0.1em;
}
</style>
